import { useCallback } from 'react';
import useSWR from 'swr';
import { ReportBilling } from '../types';
import { apiClient } from '../services/apiClient';

interface UseReportBillingReturn {
  /** null = report non billing-eligible (nessuna riga, nessuna pagina). */
  billing: ReportBilling | null;
  loading: boolean;
  error: Error | undefined;
  refresh: () => Promise<void>;
}

export const useReportBilling = (reportId: string | undefined): UseReportBillingReturn => {
  const { data, error, isLoading, mutate } = useSWR<ReportBilling | null, Error>(
    reportId ? `/api/v1/reports/${reportId}/billing` : null,
    () => apiClient.getReportBilling(reportId!),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5000,
    }
  );

  const refresh = useCallback(async (): Promise<void> => {
    await mutate();
  }, [mutate]);

  return {
    billing: data ?? null,
    loading: isLoading,
    error,
    refresh,
  };
};
